import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface ChevronDownProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const ChevronDown: React.FunctionComponent<React.PropsWithChildren<ChevronDownProps>> = ({
    fill,
    title,
    height,
    width,
    ...rest
}): any => (
    <SVGBase viewBox="0 0 444.818 444.819" height={height} width={width} title={title} fill={fill} {...rest}>
        <path
            d="M269.8,196.712,83.662,10.848Q73.38,0,57.965,0t-25.7,10.848L10.57,32.264A34.965,34.965,0,0,0,0,57.956,36.551,36.551,0,0,0,10.57,83.937L149.323,222.41,10.564,361.168A34.971,34.971,0,0,0,0,386.861a36.552,36.552,0,0,0,10.564,25.98l21.7,21.413a34.983,34.983,0,0,0,25.7,10.564,34.973,34.973,0,0,0,25.7-10.564L269.8,248.39a36.556,36.556,0,0,0,10.571-25.981A34.969,34.969,0,0,0,269.8,196.712Z"
            transform="translate(444.818) rotate(90)"
        />
    </SVGBase>
);

export default ChevronDown;
